module.exports = __webpack_public_path__ + "img/authenticate.f5e0f6fe.jpg";